import React from 'react';
import { MdArrowBack, MdDirectionsCar, MdShield, MdPhoneInTalk, MdChevronRight } from 'react-icons/md';

const AutoServicesScreen = ({ onNavigate, onBack }) => {
  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Auto Services</h1>
        </div>
      </header>

      <div className="scroll-content gray-bg">

        {/* Vehicle Summary */}
        <div className="auto-svc-section-label">Your Vehicle</div>
        <div className="auto-svc-vehicle-card">
          <div className="auto-svc-vehicle-icon"><MdDirectionsCar size={32} color="var(--td-green)" /></div>
          <div className="auto-svc-vehicle-info">
            <div className="auto-svc-vehicle-name">2021 Honda Civic</div>
            <div className="auto-svc-vehicle-sub">TD Auto Finance · Loan #AF-884421</div>
          </div>
        </div>
        <div className="emt-section" style={{ marginTop: 0 }}>
          <div className="emt-review-row">
            <span className="emt-review-label">Loan Balance</span>
            <span className="emt-review-value" style={{ fontWeight: 700, color: 'var(--text-dark)' }}>$14,200.00</span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Monthly Payment</span>
            <span className="emt-review-value">$387.50</span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Next Payment</span>
            <span className="emt-review-value" style={{ color: 'var(--td-green)', fontWeight: 600 }}>Apr 15, 2026</span>
          </div>
          <div className="emt-review-row" style={{ border: 'none' }}>
            <span className="emt-review-label">Term Remaining</span>
            <span className="emt-review-value">31 months</span>
          </div>
        </div>

        {/* Make a Payment */}
        <button className="emt-primary-btn" onClick={() => onNavigate('billPayment')}>Make a Payment</button>

        {/* Auto Insurance */}
        <div className="auto-svc-section-label">Auto Insurance</div>
        <div className="emt-section" style={{ marginTop: 0 }}>
          <div className="auto-svc-insurer-row">
            <MdShield size={22} color="var(--td-green)" style={{ marginRight: 10, flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div className="auto-svc-insurer-name">TD Insurance</div>
              <div className="auto-svc-insurer-sub">Policy #TDI-2021-88423</div>
            </div>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Renewal Date</span>
            <span className="emt-review-value">April 2027</span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Coverage</span>
            <span className="emt-review-value">Comprehensive + Collision</span>
          </div>
          <div className="emt-review-row" style={{ border: 'none', paddingBottom: 14 }}>
            <span className="emt-review-label">Premium</span>
            <span className="emt-review-value">$112.00 / month</span>
          </div>
          <button className="auto-svc-outline-btn" onClick={() => alert('TD Insurance portal — coming soon')}>View Policy Details</button>
        </div>

        {/* TD Auto Finance Contact */}
        <div className="auto-svc-section-label">TD Auto Finance</div>
        <div className="emt-section" style={{ marginTop: 0 }}>
          <div className="auto-svc-contact-row">
            <MdPhoneInTalk size={18} color="var(--td-green)" style={{ marginRight: 10 }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-dark)' }}>1-800-659-3368</div>
              <div style={{ fontSize: 11, color: 'var(--text-medium)', marginTop: 2 }}>Mon–Fri 8am–8pm ET · Sat 9am–5pm ET</div>
            </div>
          </div>
        </div>

        {/* Finance a New Vehicle */}
        <div className="auto-svc-finance-banner" onClick={() => alert('TD Auto Finance — coming soon')}>
          <div>
            <div className="auto-svc-finance-title">Finance a New Vehicle</div>
            <div className="auto-svc-finance-sub">Get pre-approved in minutes</div>
          </div>
          <MdChevronRight size={22} color="white" />
        </div>

        <div style={{ height: 16 }} />
      </div>
    </div>
  );
};

export default AutoServicesScreen;
